import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
export function* setClinicalUser() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { isClinicalUser, signer, signerList } = signerState
  const selectedClinicalUser = signerList.filter((u) => u.key === signer?.key)
  if (selectedClinicalUser && selectedClinicalUser.length) {
    selectedClinicalUser[0].isClinicalUser = isClinicalUser
    yield put(setSignerList(signerList))
  }
}
export function* setClinicalUserSaga() {
  yield takeLatest([CompleteChartConstants.SET_CLINICAL_USER], performWithMutexHOG, setClinicalUser)
}
